import React from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Container, Row, Col, Button } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router";

import "./BareOffer.styl";
import Modal from "../offer/Modal";
import { get } from "../../common/offer/actions";
import { setLocation } from "../../common/app/actions";
import { setIsShown } from "../components/HeaderResponsive/actions";

moment.locale("pl");

class BareOffer extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpen: false
    };

    this.toggleIsOpen = this.toggleIsOpen.bind(this);
    this.getOffer = this.getOffer.bind(this);
  }

  componentDidMount() {
    const { setIsShown } = this.props;
    setIsShown(false);
    window.scrollTo(0, 0);
    this.getOffer();
  }

  async getOffer() {
    const { get, params, setLocation, location } = this.props;

    const slug = params.slug;
    const rs = await get({ slug });
    if (rs && rs.status === 404) {
      this.redirect("/404");
      let loc = location;
      loc.pathname = "/404";
      setLocation(loc);
    }
  }

  toggleIsOpen() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const { location, params, map, apiHost, appPath, agencyUID } = this.props;

    const slug = params.slug;
    const obj = map.get(slug);

    const seoTitle = obj && obj.get("title");
    const shortDesc = obj && obj.get("shortDesc") ? obj.get("shortDesc") : "";
    const seoDescription = shortDesc.substring(0, 160);

    const isDeleted = obj && obj.get("isDeleted");
    const isFromOurAgency = obj && obj.get("agency");
    const isFromApp =
      obj &&
      obj.get("agency") &&
      obj.get("offerDesc") === "" &&
      obj.get("healthDesc") === "";

    return (
      <div>
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/home-background.jpg"
            }
          ]}
        />
        <div className="offer-page">
          <div className="width-wrapper">
            <Link
              className="show-offer btn btn-secondary btn-lg bare-offer__link"
              to={`${appPath}/offers/${agencyUID}`}
            >
              <i className="fa fa-angle-left bare-offer__icon bare-offer-icon" />
              WSTECZ
            </Link>
          </div>

          {isDeleted && <div className="deleted">Ogłoszenie nieaktualne</div>}

          <div className="hero-section">
            <div className="width-wrapper">
              <h1 className="title-large">{obj && obj.get("title")}</h1>
              <div className="title-small">
                <span>
                  <i className="fa fa-map-marker" /> {obj && obj.get("city")}
                </span>
                <span>
                  <i className="fa fa-calendar" /> Dodany{" "}
                  {obj && moment(obj.get("createdAt")).fromNow()}
                </span>
                <span>
                  <i className="fa fa-clock-o" /> Data wyjazdu:{" "}
                  {obj && moment(obj.get("startDate")).format("DD.MM.YYYYr.")}
                </span>
              </div>
            </div>
          </div>

          <div className="offer-single-section">
            <div className="width-wrapper">
              <Container>
                <Row>
                  <Col xs="12">
                    <div className="item-wrapper">
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          {!isDeleted && (
                            <Button
                              className="show-more"
                              color="secondary"
                              size="lg"
                              tag="a"
                              onClick={this.toggleIsOpen}
                            >
                              APLIKUJ DO AGENCJI
                            </Button>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12">
                          <div className="separator" />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12">
                          <div className="section-title">
                            {obj && obj.get("title")}
                          </div>
                          <div className="section-title-second-line">
                            <span>
                              <i className="fa fa-map-marker" />{" "}
                              {obj && obj.get("city")}
                            </span>
                            <span>
                              <i className="fa fa-calendar" /> Dodany{" "}
                              {obj && moment(obj.get("createdAt")).fromNow()}
                            </span>
                            <span>
                              <i className="fa fa-clock-o" /> Data wyjazdu:{" "}
                              {obj &&
                                moment(obj.get("startDate")).format(
                                  "DD.MM.YYYYr."
                                )}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      <Row className="flex-items-xs-center">
                        <Col xs="12">
                          <div className="offer-content">
                            <div className="header">Opis oferty</div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: obj && obj.getIn(["mainDesc"])
                              }}
                            />
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div className="header">Stan zdrowia</div>
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj && obj.getIn(["healthDesc"])
                                  }}
                                />
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div className="header">Termin wyjazdu</div>
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj && obj.getIn(["whenDesc"])
                                  }}
                                />
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div className="header">Wymagania klienta</div>
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj && obj.getIn(["clientReqDesc"])
                                  }}
                                />
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div className="header">Nasza oferta</div>
                              )}
                            {isFromOurAgency &&
                              !isFromApp && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj && obj.getIn(["offerDesc"])
                                  }}
                                />
                              )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          {!isDeleted && (
                            <Button
                              className="show-more"
                              color="secondary"
                              size="lg"
                              tag="a"
                              onClick={this.toggleIsOpen}
                            >
                              APLIKUJ DO AGENCJI
                            </Button>
                          )}
                          <Modal
                            isOpen={this.state.isOpen}
                            toggleAction={this.toggleIsOpen}
                            offerUID={obj && obj.get("uid")}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-right" xs="12">
                          <div className="separator" />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          <div className="agency-logo">
                            {obj &&
                              obj.getIn(["agency", "logoFileUID"]) && (
                                <img
                                  src={
                                    apiHost +
                                    "/v1/agency/image/" +
                                    obj.getIn(["agency", "logoFileUID"])
                                  }
                                />
                              )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          <div className="agency-name">
                            {obj &&
                              (obj.getIn(["agency", "name"]) ||
                                obj.getIn(["agencyName"]))}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          <div className="agency-description">
                            {obj &&
                              (obj.getIn(["agency", "description"]) ||
                                obj.getIn(["agencyDescription"]))}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-xs-center" xs="12">
                          <div className="agency-url">
                            <a
                              href={
                                obj &&
                                (obj.getIn(["agency", "agencyUrl"]) ||
                                  obj.getIn(["agencyUrl"]))
                              }
                              target="_blank"
                              rel="nofollow noopener noreferrer"
                            >
                              {obj &&
                                obj.getIn(["agency", "agencyUrl"]) && (
                                  <i className="fa fa-link" />
                                )}
                              {obj &&
                                (obj.getIn(["agency", "agencyUrl"]) ||
                                  obj.getIn(["agencyUrl"]))}
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    appPath: state.config.appPath,
    apiHost: state.config.apiHost,
    map: state.offer.map,
    agencyUID: state.offer.map.getIn([ownProps.params.slug, "agencyUID"])
  }),
  { get, setLocation, setIsShown }
)(BareOffer);



/** WEBPACK FOOTER **
 ** ./src/browser/offers/BareOffer.js
 **/